/*
 * Author: harper
 * File Created: Saturday, 23-07-15 10:10 am
 * Last Modified: Wednesday, 24-09-04 09:52 pm, by Roger
 * Copyright © 2023 - Liberty MIT
 */

import type { StyledComponent } from '@emotion/styled';

import type { AppBarProps } from '@mui/material';
import {
  AppBar,
  appBarClasses,
  Avatar,
  Button,
  styled,
  Toolbar,
} from '@mui/material';

export const StyledHeader: StyledComponent<AppBarProps> = styled(AppBar)(
  () => ({
    [`&.${appBarClasses.root}`]: {
      boxShadow: 'none',
      // border: `1px solid ${theme.palette.primary.main}`,
      backgroundColor: '#111217',
      backgroundImage: 'none',
    },
    // [theme.breakpoints.down('sm')]: {
    //     display: 'none'
    // }
  }),
);

export const StyledToolbar = styled(Toolbar)(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '0 20px',
  height: '44px',
  minHeight: '44px',
}));

export const StyledLoginButton = styled(Button)(() => ({
  display: 'flex',
  height: '30px',
  padding: '4px 16px',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '10px',
  flexShrink: 0,
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '22px',
  borderColor: '#4F5867',
}));

export const HeaderAvatar = styled(Avatar)(() => ({
  width: '24px',
  height: '24px',
  cursor: 'pointer',
}));
